import Chip from "@mui/material/Chip";
import type { WebhookOutcome } from "@/api/webhook-log/_models/WebhookLog";

interface WebhookLogListOutcomeChipProps {
  outcome: WebhookOutcome;
}

type MuiColor = "default" | "success" | "warning" | "error";

const OUTCOME_COLORS: Record<WebhookOutcome, MuiColor> = {
  handled: "success",
  unhandled: "default",
  failed: "error",
  rejected: "warning",
};

/** What the receiver (or a replay) did with the event. */
export const WebhookLogListOutcomeChip = (props: WebhookLogListOutcomeChipProps) => {
  const { outcome } = props;

  return (
    <Chip
      color={OUTCOME_COLORS[outcome] ?? "default"}
      label={outcome}
      size="small"
      variant="outlined"
    />
  );
};
